import { useRouter } from 'next/router';

import { getQueryParamAsString } from 'utils/getQueryParamAsString';

export function useGetAppointmentId() {
  const {
    query: { appointmentId },
  } = useRouter();

  return { appointmentId: getQueryParamAsString(appointmentId) ?? '' };
}
